// Copyright (c) 2017 Deere & Company

import {
    Component,
    PropTypes
} from 'react';
import {environmentIsProd, environmentIsReady} from '../shared/services/environment';
import {setAppDynamicsConfig} from '../shared/services/appdynamics';

class AppDynamics extends Component {

    componentWillMount = () => {

        this.setState({
            initComplete: false
        });

    };

    componentDidUpdate() {

        if (!this.state.initComplete && environmentIsReady(this.props.appConfig)) {

            const isProd = environmentIsProd(this.props.appConfig);

            setAppDynamicsConfig(isProd);

            const script = document.createElement('script');

            script.src = 'https://cdn.appdynamics.com/adrum/adrum-4.4.3.717.js';
            script.async = true;

            document.body.appendChild(script);

            this.markComplete();

        }

    }

    markComplete = () => {

        this.setState({
            initComplete: true
        });

    };

    render = () => null;

}

AppDynamics.displayName = 'AppDynamics';
AppDynamics.propTypes = {
    appConfig: PropTypes.object.isRequired
};

export default AppDynamics;



// WEBPACK FOOTER //
// ./src/app/appdynamics.js